import api from './api';

export const testimonialService = {
    getAllTestimonials: async (params) => {
        return api.getAllTestimonials(params);
    },

    updateTestimonial: async (id, data) => {
        return api.updateTestimonial(id, data);
    }
};
